/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from './initialState';
var pipelineVersionUpdated = produce(function (draft, action) {
  var pipelineVersion = action.payload.pipelineVersion;
  draft.info.pipelineVersion = pipelineVersion;
}, initialState);
export default pipelineVersionUpdated;